import axios, { AxiosResponse } from 'axios'
import {
  ChargeException,
  ChargeExceptions,
  PostChargeExceptions,
} from '../models/ChargeException.type'
import { clean } from '../utility/jsonFunctions'
import { getUserToken } from '../utility/localStorageFunctions'
import {
  FixedRoute,
  FixedRoutes,
  Supplier,
  SupplierAPIResponse,
} from './suppliers.types'

const BASE_URL = `${process.env.REACT_APP_BASE_API_URL}/suppliers-api/suppliers`

const getSuppliers = async (): Promise<AxiosResponse<SupplierAPIResponse>> => {
  const token = await getUserToken('suppliers')

  const response = await axios({
    method: 'get',
    url: BASE_URL + '?limit=10000',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

async function searchSuppliers() {
  const token = await getUserToken('suppliers')

  const response = await axios({
    method: 'POST',
    url: `${BASE_URL}/search`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: {
        status: ['Onboarding', 'Active', 'Suspended', 'Inactive'],
      },
    },
  })
  return response
}

const getSupplierById = async (
  id: string,
): Promise<AxiosResponse<Supplier>> => {
  const token = await getUserToken('suppliers')

  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${id}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}
const getChargeExceptions = async (
  id: number,
): Promise<AxiosResponse<ChargeExceptions>> => {
  const token = await getUserToken('suppliers')

  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${id}`).concat(`/chargeExceptions`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const createSupplier = async (supplier: Supplier) => {
  clean(supplier)
  const token = await getUserToken('suppliers')

  const response = await axios({
    method: 'post',
    url: BASE_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: {
        ...supplier,
      },
    },
  })
  return response
}

const updateSupplier = async (supplier: Supplier, id: number) => {
  const token = await getUserToken('suppliers')

  const response = await axios({
    method: 'patch',
    url: BASE_URL?.concat(`/${id}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: {
        ...supplier,
      },
    },
  })
  return response
}

const mapChargeException = (chargeException: ChargeException) => {
  let mapped = {
    ...chargeException,
    chargeExceptionTypeName: 'Custom',
    isDefault: false,
  }
  if (chargeException.customExceptionTypeName === 'Time') {
    return {
      ...mapped,
      appliesFromTimeHour: Number(chargeException.appliesFromTimeHour),
      appliesFromTimeMinute: Number(chargeException.appliesFromTimeMinute),
      appliesToTimeHour: Number(chargeException.appliesToTimeHour),
      appliesToTimeMinute: Number(chargeException.appliesToTimeMinute),
    }
  }
  return mapped
}
const createChargeException = async (payload: PostChargeExceptions) => {
  const { chargeException, supplierId } = payload
  clean(chargeException)
  console.log('createChargeException - ', payload)
  const mapped = mapChargeException(chargeException)
  console.log('mapped  -  ', mapped)

  const token = await getUserToken('suppliers')

  const response = await axios({
    method: 'post',
    url: BASE_URL?.concat(`/${supplierId}`).concat(`/chargeExceptions`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: {
        ...mapped,
      },
    },
  })
  return response
}

const deleteSupplier = async (supplierId: number) => {
  const token = await getUserToken('suppliers')

  const response = await axios({
    method: 'delete',
    url: BASE_URL?.concat(`/${supplierId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const deleteChargeException = async (
  supplerId: number,
  chargeExceptionId: number,
) => {
  const token = await getUserToken('suppliers')

  const response = await axios({
    method: 'delete',
    url: BASE_URL?.concat(
      `/${supplerId}/chargeExceptions/${chargeExceptionId}`,
    ),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const getSupplierFixedRoutes = async (
  id: number,
): Promise<AxiosResponse<FixedRoutes>> => {
  console.log(`fetching supplier fixed routes ${id}`)
  const token = await getUserToken('suppliers')

  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${id}/fixedRoutes`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const deleteSupplierFixedRoute = async (
  supplierId: number,
  fixedRouteId: number,
) => {
  const token = await getUserToken('suppliers')

  const response = await axios({
    method: 'delete',
    url: BASE_URL?.concat(`/${supplierId}/fixedRoutes/${fixedRouteId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const createSupplierFixedRoute = async (
  supplierId: number,
  fixedRoute: FixedRoute,
) => {
  clean(fixedRoute)
  const token = await getUserToken('suppliers')

  const response = await axios({
    method: 'post',
    url: BASE_URL?.concat(`/${supplierId}/fixedRoutes`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: {
        ...fixedRoute,
      },
    },
  })
  return response
}

const updateSupplierFixedRoute = async (
  supplierId: number,
  fixedRouteId: number,
  fixedRoute: FixedRoute,
) => {
  clean(fixedRoute)
  const token = await getUserToken('suppliers')

  const response = await axios({
    method: 'patch',
    url: BASE_URL?.concat(`/${supplierId}/fixedRoutes/${fixedRouteId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: {
        ...fixedRoute,
      },
    },
  })
  return response
}

export const suppliersAPI = {
  getSuppliers,
  searchSuppliers,
  getSupplierById,
  getChargeExceptions,
  createChargeException,
  createSupplier,
  updateSupplier,
  deleteSupplier,
  deleteChargeException,
  getSupplierFixedRoutes,
  createSupplierFixedRoute,
  updateSupplierFixedRoute,
  deleteSupplierFixedRoute,
}
